import * as React from 'react';

import {EmbedOrShareModal} from 'shells/embed-or-share-modal/embed-or-share-modal';
import {FlashBanner} from 'shells/flash-banner/flash-banner';

type Props = {
    meetingIsActive: boolean;
    publicMeetingLink: string;
    embedSnippet: string;
    onClose: () => void;
};

export function ShareMeetingModal(props: Props) {
    return (
        <EmbedOrShareModal
            onClose={props.onClose}
            header='Share meeting'
            additionalContent={
                props.meetingIsActive ? undefined : (
                    <div className='mb-16'>
                        <FlashBanner hasBorder={true} type='warning' animate={false}>
                            Enable the ‘<strong>Let people book this meeting</strong>’ option to
                            allow others to view and book this meeting
                        </FlashBanner>
                    </div>
                )
            }
            codeSnippet={props.embedSnippet}
            embedInfoPopoverText='Copy and paste this code snippet into your website where you’d like to show this meeting.'
            copyableLinkLabel='Meeting link'
            copyableLink={props.publicMeetingLink}
        />
    );
}
